











































































import { Component, Vue, Watch } from 'vue-property-decorator'
import base_ds from '@/services/base_datasource_service';
import UserService from '@/services/data/user_manager';
import RoleService from '@/services/data/role_manager';
import {DxTextBox} from 'devextreme-vue';
import DButton from '@/components/DButton/button.vue';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import TableGrid from '@/components/TableGrid/grid.vue';
import {confirm} from 'devextreme/ui/dialog';
import UserEditPopup from './components/edit-popup.vue'
import AdUserEditPopup from './components/ad-user-edit-popup.vue'
import UserLogsPopup from './components/user_logs.vue'
import AuthService from '@/services/auth_service';
import EcoObjectsService from "@/services/eco-objects-service";
import {EcoFilialSelectionType, EcoFilialNodeMapType, EcoObjectType} from "@/services/models-service";

@Component({
  name: 'Users',
  components: {
    DButton,
    DSelectbox,
    DxTextBox,
    TableGrid,
    UserEditPopup,
    UserLogsPopup,
    AdUserEditPopup,
  }
})
export default class extends Vue {

  public service = UserService;
  public roleService = RoleService;
  public ecoObjectsService = EcoObjectsService;

  public authService = AuthService;
  public userTableColumns: any[] = [];
  public userLogsPopup = {
    visible: false
  };
  public heat_nodes_ds: EcoObjectType[] = [];
  public filial_ds: EcoObjectType[] = [];

  private selectionData: EcoFilialSelectionType[] = [];
  public adCheckResults: Record<string, boolean> = {};
  public adCheckLoading: boolean = false;
  public adCheckSortDesc: boolean = false;
  public adCheckActive: boolean = false;
  public adCheckKey: number = 0;

  public popupType: string = ''

  get isADAuth(): boolean {
    return this.authService.isActiveDirectoryAuth()
  }

  created() {
    localStorage.removeItem('suersIndexGrid');
    this.initUserColumns(false);

    Promise.all([this.ecoObjectsService.get_merged_all_heat_nodes()]).then((responses) => {
      const data = responses[0]?.data || [];

      // Фильтрация по уникальному ключу id
      this.heat_nodes_ds = data.filter((item, index, self) => index === self.findIndex((t) => JSON.stringify(t) === JSON.stringify(item)));
    });
  }


  mounted() {
    this.service.setCurrentRow(null);
  }

  visiblePopup(type: string) {
    if (type == 'AD'){
      this.popupType = 'AD'
    } else {
      this.popupType = 'noAD'
    }
  }

  destroyed() {

  }

  initUserColumns(adExistsVisible: Boolean) {
    this.userTableColumns = [
      {
        dataField: 'id',
        visible: false
      },

      {
        dataField: 'filials',
        caption: 'Филиалы',
        calculateCellValue: (rowData: any) => {
          if (!rowData.filials || !Array.isArray(rowData.filials)) return '-';
          return rowData.filials.join(', ');
        },
        visible: true,
        index: 0,
      },
      {
        dataField: 'login',
        caption: 'Логин пользователя',
        sortOrder: 'asc',
        cellTemplate: (container: any, options: any) => {
          // Создаём контейнер для иконок и логина
          const iconEdit = document.createElement('span');
          iconEdit.className = 'user-action-icon edit';
          iconEdit.title = 'Редактировать';
          iconEdit.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9c27b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19.5 2 21l1.5-5L16.5 3.5z"/></svg>`;
          iconEdit.style.cursor = 'pointer';
          iconEdit.style.marginRight = '8px';
          iconEdit.onclick = (e: Event) => {
            e.stopPropagation();
            this.onEditUser({ row: { data: options.data } });
          };

          const iconAccess = document.createElement('span');
          iconAccess.className = 'user-action-icon access';
          iconAccess.title = 'Настройка доступа';
          iconAccess.innerHTML = `<svg width="20" height="20" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <path fill="#9c27b0" d="M424.5,216.5h-15.2c-12.4,0-22.8-10.7-22.8-23.4c0-6.4,2.7-12.2,7.5-16.5l9.8-9.6c9.7-9.6,9.7-25.3,0-34.9l-22.3-22.1
    c-4.4-4.4-10.9-7-17.5-7c-6.6,0-13,2.6-17.5,7l-9.4,9.4c-4.5,5-10.5,7.7-17,7.7c-12.8,0-23.5-10.4-23.5-22.7V89.1
    c0-13.5-10.9-25.1-24.5-25.1h-30.4c-13.6,0-24.4,11.5-24.4,25.1v15.2c0,12.3-10.7,22.7-23.5,22.7c-6.4,0-12.3-2.7-16.6-7.4l-9.7-9.6
    c-4.4-4.5-10.9-7-17.5-7s-13,2.6-17.5,7L110,132c-9.6,9.6-9.6,25.3,0,34.8l9.4,9.4c5,4.5,7.8,10.5,7.8,16.9
    c0,12.8-10.4,23.4-22.8,23.4H89.2c-13.7,0-25.2,10.7-25.2,24.3V256v15.2c0,13.5,11.5,24.3,25.2,24.3h15.2
    c12.4,0,22.8,10.7,22.8,23.4c0,6.4-2.8,12.4-7.8,16.9l-9.4,9.3c-9.6,9.6-9.6,25.3,0,34.8l22.3,22.2c4.4,4.5,10.9,7,17.5,7
    c6.6,0,13-2.6,17.5-7l9.7-9.6c4.2-4.7,10.2-7.4,16.6-7.4c12.8,0,23.5,10.4,23.5,22.7v15.2c0,13.5,10.8,25.1,24.5,25.1h30.4
    c13.6,0,24.4-11.5,24.4-25.1v-15.2c0-12.3,10.7-22.7,23.5-22.7c6.4,0,12.4,2.8,17,7.7l9.4,9.4c4.5,4.4,10.9,7,17.5,7
    c6.6,0,13-2.6,17.5-7l22.3-22.2c9.6-9.6,9.6-25.3,0-34.9l-9.8-9.6c-4.8-4.3-7.5-10.2-7.5-16.5c0-12.8,10.4-23.4,22.8-23.4h15.2
    c13.6,0,23.3-10.7,23.3-24.3V256v-15.2C447.8,227.2,438.1,216.5,424.5,216.5z M336.8,256L336.8,256c0,44.1-35.7,80-80,80
    c-44.3,0-80-35.9-80-80l0,0l0,0c0-44.1,35.7-80,80-80C301.1,176,336.8,211.9,336.8,256L336.8,256z"/>
</svg>`
          iconAccess.style.cursor = 'pointer';
          iconAccess.style.marginRight = '8px';
          iconAccess.onclick = (e: Event) => {
            console.log("onclick")
            e.stopPropagation();
            this.onAccessUser(options.data);
          };

          const loginText = document.createElement('span');
          loginText.textContent = options.value;
          loginText.style.verticalAlign = 'middle';

          container.appendChild(iconEdit);
          container.appendChild(iconAccess);
          container.appendChild(loginText);
        }
      },
      {
        dataField: 'full_name',
        caption: 'Полное имя'
      },
      {
        dataField: 'role',
        caption: 'Роль пользователя',
        lookup: {
          dataSource: this.roleService.roles,
          valueExpr: 'id',
          displayExpr: 'description'
        }
      },
      {
        dataField: 'email',
        caption: 'E-mail',
        dataType: 'string',
      },
      {
        dataField: 'last_access',
        caption: 'Дата последнего входа',
        dataType: 'date',
      },
      // ad_exists добавляется только если adCheckActive === true
      {
        dataField: 'ad_exists',
        caption: 'Наличие в AD',
        dataType: 'boolean',
        allowSorting: true,
        width: 120,
        visible: adExistsVisible,
        sortIndex: 1,
      },
      {
        dataField: 'disabled',
        caption: 'Деактивирован',
        dataType: 'boolean',
        calculateCellValue: this.calculateDisabled,
        width: 150
      },
      // Кнопки справа: только удалить
      {
        maxWidth: '120',
        type: 'buttons',
        caption: '',
        visible: this.authService.isAdmin(),
        buttons: [
          {
            icon: 'close',
            color: 'red',
            hint: 'Удалить',
            cssClass: 'grid-icon_button',
            onClick: this.onDeleteUser
          }
        ]
      }
    ];
  }

  private showPwd() {
  }
  empty() {
    //
  }


  calculateDisabled(rowData: any): boolean {
    return rowData.disabled === true;
  }

  onAddUser(type: string) {
    // Заполнить дерево выбора согласно загруженному маппингу ТУ - Филиал
    this.fillSelectionData();
    this.visiblePopup(type)
    this.service.setEditPopupVisible(true);
  }

  onEditUser(e: any = null) {
    // Если функция вызывается из обработчика нажатия кнопки
    if (e?.row?.data) {
      this.service.setCurrentRow(e.row.data);
    }
    // Заполнить дерево выбора согласно загруженному маппингу ТУ - Филиал
    this.fillSelectionData();
    this.service.setEditPopupMode(true);
    this.service.setEditPopupVisible(true);
  }

  onGetUserLogs(e: any = null) {
    // Если функция вызывается из обработчика нажатия кнопки
    if (e?.row?.data) {
      this.service.setCurrentRow(e.row.data);
    }
    this.userLogsPopup.visible = true;
  }

  onDeleteUser(e: any = null) {
    // Если функция вызывается из обработчика нажатия кнопки
    if (e?.row?.data) {
      this.service.setCurrentRow(e.row.data);
    }

    confirm('Вы уверены, что хотите удалить пользователя?', 'Удаление пользователя')
      .then(async (answer: boolean) => {
        if (!answer) {
          return
        }

        try {
          await this.service.deleteUser(this.service.selected_row);
          try { await this.service.userDataSource.reload(); } catch(e) { if (e !== 'canceled') throw e; }
          this.service.setCurrentRow(null);

        } catch (e) {
          console.log(e)
        }
      })
  }

  onRowClick(e: any) {
    this.service.selected_row = e.data;
  }

  @Watch('heat_nodes_ds', { immediate: true })
  changeNodeDs() {
    this.fillSelectionData();
  }

  fillSelectionData() {
    // Если мы не в режиме логина через ActiveDirectory или структура дерева была создана ранее - выход
    if (this.selectionData.length) {
      return;
    }
    this.selectionData = [];
    this.heat_nodes_ds.forEach( heatNode => {
      // Для Узла найти филиал в дереве выбора среди уже добавленных по id филиала
      // id филиала извлечь из маппинга ТУ-Филиал
      const filialId = heatNode.filial_id;
      if (filialId) {
        const selIdx = this.selectionData.findIndex(item => item.id === filialId);
        if (selIdx === -1) {
          // Филиал еще не добавлен, добавить его в список выбора и добавит текущий узел в список узлов
          this.selectionData.push({
            id: heatNode.filial_id as number,
            name: heatNode.filial_name as string,
            check: false,
            nodes: [ { id: heatNode.id,
              check: false,
              name: heatNode.name } ],
          });
        } else {
          // Филиал уже добавилен, для него обновить список узлов
          this.selectionData[selIdx].nodes.push({ id: heatNode.id, check: false, name: heatNode.name });
        }
      }
    });
  }
  async onCheckUsersInAD() {
    this.adCheckLoading = true;
    try {
      const results = await this.service.checkUsersExistInAD();
      if (results) {
        // Преобразуем ответ в формат для push
        const updates = results.map((r: any) => ({
          type: 'update',
          key: r.user_id,
          data: { ad_exists: r.ad_exists ?? false }
        }));

        // Обновляем данные в DataSource
        (this.service.userDataSource.store()  as any).push(updates);

        // Включаем колонку "Наличие в AD"
        this.adCheckActive = true;
        this.initUserColumns(true);

        // Пересоздаём таблицу
        // this.adCheckKey++;
      }
    } catch (e) {
      console.error('Ошибка при проверке пользователей в AD:', e);
    } finally {
      this.adCheckLoading = false;
    }
  }


  // async onCheckUsersInAD() {
  //   this.adCheckLoading = true;
  //   try {
  //     const results = await this.service.checkUsersExistInAD();
  //     if (results) {
  //       const adMap = Object.fromEntries(results.map(r => [r.user_id, r.ad_exists]));
  //       const users = this.service.userDataSource.items ? this.service.userDataSource.items() : [];
  //       users.forEach((user: any) => {
  //         user.ad_exists = adMap[user.id] ?? false;
  //         console.log(user.ad_exists);

  //       });
  //       this.adCheckActive = true;
  //       this.initUserColumns(true);
  //       this.adCheckKey++;
  //       this.$nextTick(() => {
  //         const grid = this.$refs.tableGrid as any;
  //         if (grid && grid.refresh) grid.refresh();
  //       });
  //     }
  //   } finally {
  //     this.adCheckLoading = false;
  //   }
  // }

  onUserRowPrepared(e: any) {
    if (e.rowType === 'data' && e.data.ad_exists === false) {
      e.rowElement?.classList?.add('ad-missing-row');
      console.log('row prepared afeer if',  e.rowElement?.classList);
    }
  }

  onCellPrepared(e: any) {
    if (e.rowType === 'data' && e.data && e.data.ad_exists === false) {
      if (e.cellElement) {
        e.cellElement.classList.add('ad-missing-cell');
      }
    }
  }

  // Вспомогательная функция для поиска компонента Home в дереве компонентов
  findHomeComponent(vm: any): any {
    if (!vm) return null;
    if (vm.$options && vm.$options.name === 'Home') return vm;
    for (let i = 0; i < (vm.$children || []).length; i++) {
      const found = this.findHomeComponent(vm.$children[i]);
      if (found) return found;
    }
    return null;
  }

  onAccessUser(user: any) {
    (this.$root as any)._userAccessSelectId = user.id;
    const setTab = () => {
      // Ищем компонент Home надёжно
      const homeComp = this.findHomeComponent(this.$root);
      if (homeComp) {
        homeComp.currentTab = 'user_access';
      }
    };
    if (this.$route.path === '/settings') {
      setTab();
    } else {
      this.$router.push({ path: '/settings' }).then(() => {
        setTab();
      });
    }
  }
}
